import Vue from 'vue';
import { ReturnTop } from 'lib-vcomponents';
Vue.use(ReturnTop);
